import React from "react";
import logo from "@/assets/Logo.png";

export default function Logo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex flex-col items-center ${className}`}>
      <img
        src={logo}
        alt="Kivas Logo"
        className="w-20 h-20 min-w-[60px] min-h-[60px] object-contain flex-shrink-0"
      />
    </div>
  );
}
